import styled from 'styled-components'
import { WrapperProps } from './types'

export const Wrapper = styled.div<WrapperProps>`
  bottom: 2.5rem;
  position: fixed;
  right: 2.5rem;

  transition: 0.25s linear;
  z-index: 2;

  ${({ visible }) => (visible
    ? `
    opacity: 1;
    `
    : `
    opacity: 0;
    `
  )}

  /* mobile */
  @media screen and (max-width: ${({ theme }) => `calc(${theme.breakpoint.tablet} - 1px)`}) {
    bottom: calc(${({ theme }) => theme.space.s400} + 4px);
    right: 1rem;
  }

  /* tablet */
  @media only screen and (min-width: ${({ theme }) => theme.breakpoint.tablet})
  and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
    bottom: calc(${({ theme }) => theme.space.s500} + 4px);
    right: 1rem;
  }
`
